import React, { FC } from 'react'
import { useBindingsStore } from '@entities/user'
import { InfoBanner } from '@shared/ui/molecules'

const PaymentTemporarilyUnavailableBanner: FC = () => {
  const { isLoading } = useBindingsStore()

  if (isLoading) return null

  return <InfoBanner variant="orange">Оплата этим способом временно недоступна, попробуйте позднее</InfoBanner>
}

export default PaymentTemporarilyUnavailableBanner
